// import Swiper JS
import Swiper, { Navigation , Pagination, Autoplay} from 'swiper';

(function($) {
    'use strict';

    Swiper.use([Navigation,Pagination,Autoplay]);

    //Quotes slider 
    function quotesSlider() {
        var quotesSwiper = new Swiper ('.quotes-slider', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 30,
            slidesPerView: 1,
            slidesPerGroup: 1,
            passiveListeners: true, //recommended for mobile performance
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.quotes-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
    quotesSlider();


    // Quotes list slider on homepage
    function quotesListSlider() {
        var quotesListSwiper = new Swiper ('.quotes-list-slider', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 30,
            slidesPerView: 1,
            slidesPerGroup: 1,
            passiveListeners: true, //recommended for mobile performance
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.quotes-list-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
    quotesListSlider();

    //USP Slider -> Not sure if still used
    function uspListSlider() {
        var cardListSwiper = new Swiper ('.usp-list-slider', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 30,
            slidesPerView: 1,
            slidesPerGroup: 1,
            passiveListeners: true, //recommended for mobile performance
            pagination: {
                el: '.usp-list-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });
    }
    uspListSlider();

    // basic card list slider
    function cardListSlider() {
        var cardListSwiper = new Swiper ('.card-slider', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            spaceBetween: 30,
            slidesPerView: 1.4,
            slidesPerGroup: 1,
            navigation: {
                nextEl: '.card-slider-button-next',
                prevEl: '.card-slider-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.4,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });
    }
    cardListSlider();

})(jQuery);